import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toArray',
  pure: false,
})
export class ToArrayPipe implements PipeTransform {
  transform<T>(value: Iterable<T>): T[] {
    return Array.from(value);
  }
}
